<div class="header flex">
	<h3 class="dialog-text flex-1" style="--max-width: 95%">{{ isEditing ? "EDIT CYCLE" : "CREATE CYCLE" }}</h3>
	<app-icon
		class="flex-1"
		style="--max-width: 5%"
		[name]="'close'"
		[size]="'55px'"
		[color]="'white'"
		(click)="onCancel()"
	></app-icon>
</div>

<div class="content">
	<mat-dialog-content [formGroup]="createOffCycleForm">
		<div class="flex flex-row">
			<input-wrapper class="space" label="PAYROLL CYCLE ID">
				<input id="payrollCycleId" type="text" formControlName="payrollCycleId" />
				<div input-errors *ngIf="createOffCycleForm.get('payrollCycleId')?.hasError('payrollCycleIdNotUnique')">
					<div class="validation-message">
						This ID is already in use
						<app-icon class="info-icon" [name]="'info-circle'" [size]="'16'" [color]="'#DA1414'">
						</app-icon>
						<app-tooltip
							class="validation-info-tooltip"
							[position]="'top'"
							[fontSize]="'10px'"
							[containerMinWidth]="344"
							[containerPadding]="'15px'"
							[containerMarginLeft]="'4rem'"
							[containerMarginTop]="'2rem'"
							[trianlePosition]="'9.2rem'"
						>
							{{ createOffCycleForm.get("payrollCycleId")?.getError("payrollCycleIdNotUnique") }}
						</app-tooltip>
					</div>
				</div>
				<div input-errors *ngIf="createOffCycleForm.get('payrollCycleId')?.hasError('payrollCycleIdNotValid')">
					<div class="validation-message">Only numbers are accepted</div>
				</div>
			</input-wrapper>
			<input-wrapper label="PAYROLL CYCLE NAME">
				<input id="payrollCycleName" type="text" formControlName="payrollCycleName" />
			</input-wrapper>
		</div>
		<div class="flex flex-row">
			<input-wrapper class="space" label="CYCLE ID *">
				<input id="cycleId" type="text" formControlName="cycleId" />
			</input-wrapper>
			<input-wrapper label="CYCLE NAME *">
				<input id="cycleName" type="text" formControlName="cycleName" />
			</input-wrapper>
		</div>
		<div class="flex flex-row">
			<input-wrapper class="space" readonly label="CYCLE START DATE *">
				<mat-form-field appearance="outline" (click)="startDate.open()">
					<mat-datepicker-toggle matPrefix [for]="startDate">
						<app-icon
							matDatepickerToggleIcon
							class="icon-offcycle"
							[name]="'calendar_month'"
							[color]="'var(--color-primary-1000)'"
						></app-icon>
					</mat-datepicker-toggle>
					<input
						id="date"
						formControlName="cycleStartDate"
						matInput
						[matDatepicker]="startDate"
						(focus)="startDate.open()"
					/>
					<mat-datepicker #startDate></mat-datepicker>
				</mat-form-field>
				<div
					input-errors
					*ngIf="
						createOffCycleForm.get('cycleStartDate')?.touched &&
						createOffCycleForm.controls.cycleStartDate.errors?.required
					"
				>
					Cycle start date is required.
				</div>

				<div input-errors *ngIf="createOffCycleForm.hasError('startDateNotValid')">
					Date cannot be after end date.
				</div>
			</input-wrapper>

			<input-wrapper label="CYCLE END DATE *" readonly>
				<mat-form-field appearance="outline" (click)="endDate.open()">
					<mat-datepicker-toggle matPrefix [for]="endDate">
						<app-icon
							matDatepickerToggleIcon
							class="icon-offcycle"
							[name]="'calendar_month'"
							[color]="'var(--color-primary-1000)'"
						></app-icon>
					</mat-datepicker-toggle>
					<input
						id="date"
						formControlName="cycleEndDate"
						matInput
						[matDatepicker]="endDate"
						(focus)="endDate.open()"
					/>
					<mat-datepicker #endDate></mat-datepicker>
				</mat-form-field>

				<div
					input-errors
					*ngIf="
						createOffCycleForm.get('cycleEndDate')?.touched &&
						createOffCycleForm.controls.cycleEndDate.errors?.required
					"
				>
					Cycle end date is required.
				</div>

				<div input-errors *ngIf="createOffCycleForm.hasError('endDateNotValid')">
					Date cannot be before start date.
				</div>
			</input-wrapper>
		</div>

		<div class="flex flex-row">
			<input-wrapper label="REASON ">
				<textarea id="reason" class="reason-text-area" formControlName="offCycleReason"> </textarea>
			</input-wrapper>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions class="flex flex-row flex-align-stretch-end" mat-dialog-actions>
		<button class="dialog-action-button" action-buttons mat-stroked-button (click)="onCancel()">Cancel</button>
		<button
			class="dialog-action-button"
			action-buttons
			color="dark"
			mat-flat-button
			(click)="onConfirm()"
			cdkFocusInitial
			[disabled]="!createOffCycleForm.valid"
		>
			Save
		</button>
	</mat-dialog-actions>
</div>
